export default __webpack_public_path__ + "static/jose-torres-radar-icon-400px-22d98216c2e0cfd689754dce6aba839f.png";